import React from 'react';

import CooperationMaterialForm from './CooperationMaterialForm';

const CooperationReturn = () => {
  return <CooperationMaterialForm mode="return" />;
};

export default CooperationReturn;
